export default "__VITE_ASSET__c3e2eaf0__"